import * as React from 'react';
import DataTableHeader from 'components/common/table/datatable/DataTableHeader';
import DataTableLayout from 'components/common/table/datatable/DataTableLayout';
import { ConnectMember } from 'types/member';
import NewDataTableBody from 'components/common/table/datatable/NewDataTableBody';
import { connectMemberListColumns } from './MemberListColumns';

interface Props {
  memberList: ConnectMember[];
  totalPages: number;
  memberListLoading: boolean;
  onChangePage: (pageIndex: number) => void;
  currentPageIndex: number;
  totalItems: number;
}

const MemberListTable = ({
  memberList,
  totalPages,
  memberListLoading,
  onChangePage,
  currentPageIndex,
  totalItems,
}: Props) => {
  const memberListColumnData = connectMemberListColumns(totalItems, currentPageIndex);
  return (
    <DataTableLayout
      showPagination
      totalPages={totalPages}
      onChangePage={onChangePage}
      currentPageIndex={currentPageIndex}
    >
      <DataTableHeader header={memberListColumnData} />
      <NewDataTableBody
        loading={memberListLoading}
        dataList={memberList}
        columns={memberListColumnData}
      />
    </DataTableLayout>
  );
};

export default MemberListTable;
